import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ajukanJurnalHarian } from "../services/jurnalHarianService";

function InputJurnalHarian() {
  const navigate = useNavigate();
  const [tanggal, setTanggal] = useState("");
  const [pekerjaan, setPekerjaan] = useState("");
  const [catatan, setCatatan] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const result = await ajukanJurnalHarian({
      tanggal, // langsung ambil dari input date
      pekerjaan,
      catatan,
    });

    if (result.success) {
      alert("Jurnal berhasil disimpan!");
      navigate("/jurnal-harian");
    } else {
      alert(result.message || "Gagal menyimpan jurnal harian");
    }
  };

  return (
    <div className="container" style={{ paddingBottom: "80px" }}>
      <div className="d-flex align-items-center my-4">
        <button className="btn p-0" onClick={() => navigate(-1)}>
          ←
        </button>
        <h5 className="ms-3 mb-0 fw-bold">Input Jurnal Harian</h5>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label fw-bold">Tanggal</label>
          <input
            type="date"
            className="form-control"
            value={tanggal}
            onChange={(e) => setTanggal(e.target.value)}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">Pekerjaan</label>
          <input
            type="text"
            className="form-control"
            placeholder="Masukkan pekerjaan hari ini"
            value={pekerjaan}
            onChange={(e) => setPekerjaan(e.target.value)}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">Catatan</label>
          <textarea
            className="form-control"
            rows="3"
            placeholder="Masukkan catatan tambahan"
            value={catatan}
            onChange={(e) => setCatatan(e.target.value)}
          />
        </div>

        <button type="submit" className="btn btn-primary w-100">
          <i className="bi bi-save me-2"></i> Simpan
        </button>
      </form>
    </div>
  );
}

export default InputJurnalHarian;
